<template>
    <component :is="component" />
</template>
<script>
import simple from './booqit_simple'
import admin from './booqit_admin'
export default {
  components: {
    simple,
    admin
  },
  data() {
    return {
      component: 'simple'
    }
  },
  methods: {},
  computed: {
    user: {
      cache: false,
      get () {
        return this.$store.getters.user
      }
    }
  },
  mounted() {
    if (this.user.role === "super" || this.user.role === "lead") {
      this.component =  'admin'
    }
  }
}
</script>
<style lang="scss">

</style>
